import React, { useEffect, useMemo, useState } from 'react'
import AdminHook from '../../hoc/admin'
import View from './view'
import Config from './ConfigDialog'
import { getListPaginated } from '../../../modules/appointment'
import useObjectState from '../../../hooks/useObjectState'
import DisableDays from './disableDays'

const Appointments = props => {
  const [openConfig, setOpenCOnfig] = useState(false)
  const [state, setState] = useObjectState({ items: [], loading: false })
  const [openDisableDays, setOpenDisableDays] = useState(false)

  const fetcher = useMemo(() => getListPaginated(15, { isFinished: true, notPast: true }), [])

  const handleFetch = async () => {
    setState({ loading: true })
    const items = await fetcher()
    console.log('itemsFetched', items)
    setState({ items: state.items.concat(items), loading: false })
  }

  const handleScroll = () => {
    if (state.loading) return false
    const scrolled = window.scrollY
    const viewportHeight = window.innerHeight
    const fullHeight = document.getElementById('root').clientHeight
    if ((scrolled + viewportHeight + 300) < fullHeight) return false
    console.log('--fetching next page--')
    handleFetch()
  }

  // defin scroll listener
  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  })

  useEffect(() => { handleFetch() }, [])

  return (
    <>
      <Config open={openConfig} onClose={() => setOpenCOnfig(false)} />
      <DisableDays open={openDisableDays} onClose={() => setOpenDisableDays(false)} />
      <View
        onDisableDaysOpen={event => setOpenDisableDays(true)}
        onSettingsOpen={event => setOpenCOnfig(true)}
        loading={state.loading}
        items={state.items}
      />
    </>
  )
}

export default AdminHook(Appointments)
